export enum CoreMutationTypes{
    SET_NOTIFICATION='SET_NOTIFICATION',
    SET_FETCHING_PRODUCTS='SET_FETCHING_PRODUCTS',
    SET_FETCHING_ACTIVE_CUSTOMER='SET_FETCHING_ACTIVE_CUSTOMER',
    SET_FETCHING_COLLECTIONS='SET_FETCHING_COLLECTIONS',
    SET_USER_AUTHENTICATING='SET_USER_AUTHENTICATING',
    SET_USER_CREATING_PRESCRIPTION='SET_USER_CREATING_PRESCRIPTION',
    SET_ACTIVE_PRODUCT='SET_ACTIVE_PRODUCT',
    SET_PRICE_RANGE='SET_PRICE_RANGE',
}